import { StateCreator } from 'zustand'
import {
  ProjectEntity,
  ProjectMemberEntity,
  UserEntity,
} from '../../../../../server-api-hrm.type'

export type LoadType = 'fetch' | 'loadMore' | 'submit' | 'priorities'
export type MenuRefetchSignal = {
  type: 'DEPARTMENT_PROJECT' | 'GENERAL_PROJECT'
  action: 'C' | 'U' | 'D'
}

export type ProjectStore = {
  isAdmin: boolean
  isLeader: boolean
  currentUser: UserEntity | undefined | null
  members: ProjectMemberEntity[]
  projectDetail: ProjectEntity | undefined | null
  menuRefetchSignal: MenuRefetchSignal | undefined
}

const projectStore: StateCreator<ProjectStore> = () => ({
  isAdmin: false,
  isLeader: false,
  members: [],
  currentUser: undefined,
  projectDetail: undefined,
  menuRefetchSignal: undefined,
})

export default projectStore
